import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Calculator from './components/Calculator';
import FindMyCar from './components/FindMyCar';
import Careers from './components/Careers';
import Contact from './components/Contact';
import Footer from './components/Footer';

function Home() {
  return (
    <div>
      <Hero />
      <Services />
      <HowItWorks />
      <Calculator />
      <FindMyCar />
      <Contact />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/careers" element={<Careers />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
